"use strict";

import { preloadImage, toggleMenu } from "./utils";
import { productTitles, urls, tradingWidgetConfig, calcForms, videoContent } from "./constants";
import projects from "./content/projects";
import menu from "./content/menu";
import pages from "./content/pages.js";
import { callThumbnailSlider, createSlider} from "./modules/slider.js";
import sliders from "./content/sliders";
import { bracingOnChange } from "./calcs/bracingEstimator.js";
import { fastFootEstimator } from "./calcs/fastfootEstimator.js";
import { estimatorOnChange } from "./calcs/fastTubeEstimator.js";
import { languages, company } from "./company";
import { createGreetingBlock, createProductListItem, footerBlock } from "./custom_forms.js"
import { renderMap } from "./dealers_map.js";

// let lang = localStorage.getItem("user_language");
let lang = 'en'
;if (!lang) {
  lang = Object.keys(languages).find((language) => language === navigator.language?.slice(0, 2)) || "en";
  localStorage.setItem("user_language", lang);
}

const createPageHeader = ({title, content, category}, menuWrapper) => {
    const productPageHeader = document.createElement("div");

    if (title && !category) {
        const titleWrapper = document.createElement("div");
        const productPageTitle = document.createElement("h1");
        const titleUnderline = document.createElement("div");

        titleWrapper.classList.add("title-wrap");
        titleUnderline.classList.add("menu-item-underline");
        productPageTitle.classList.add("page_title")

        productPageTitle.innerHTML = title.toUpperCase();

        if (content) {
            productPageTitle.classList.add("page_headerTitle");
            productPageHeader.classList.add("page_headerWrapper", "hide_header");
            const productPageHeaderButton = document.createElement("div");
            productPageHeaderButton.classList.add("page_headerButton");
            productPageHeader.appendChild(productPageHeaderButton);
            productPageHeader.addEventListener("click", () => {
                const header = document.querySelector(".header_wrapper");
                const menuWarapper = document.querySelector(".page_menuWrapper");

                if (window.getComputedStyle(header).opacity === "1") {
                    menuWarapper.style.top = "100px";
                } else {
                    menuWarapper.style.top = "50px";
                }

                toggleMenu(menuWrapper);
            });
        } else {
            productPageHeader.classList.add("page-single-header");
        }

        titleWrapper.appendChild(productPageTitle)
        titleWrapper.appendChild(titleUnderline)
        productPageHeader.appendChild(titleWrapper)
    }

    return productPageHeader;
};

export const createPageVideo = (videos) => {
    const videoWrapper = document.createElement("div");
    videoWrapper.classList.add("page_videoWrapper");

    videos.forEach(item => {
        const videoFrame = document.createElement("iframe");
        videoFrame.classList.add("page_video");
        videoFrame.title = item.title;
        videoFrame.loading = "lazy";
        videoFrame.allowFullscreen = true;
        videoFrame.frameBorder = "0";
        videoFrame.src = item.video;
        videoWrapper.appendChild(videoFrame);
    });

    return videoWrapper;
}

const createPageImage = (images, title) => {
    const imageWrapper = document.createElement("div");
    imageWrapper.classList.add("page_imageWrapper");

    images.forEach(image => {
        preloadImage(image);
        const imageTag = document.createElement("img");
        imageTag.classList.add("page_fullImage");
        imageTag.src = image;
        imageTag.alt = title;
        imageTag.width = 1200;
        imageTag.height = 800;
        imageWrapper.appendChild(imageTag);
    });

    return imageWrapper;
}

const createPageText = (text, tag, className) => {
    const titleTag = document.createElement(tag);
    titleTag.classList.add(className);
    titleTag.innerHTML = text;

    return titleTag;
}

const createLocalVideo = (video) => {
    const videoWrapper = document.createElement("div");
    videoWrapper.classList.add("article-media-block", "media-50");
    videoWrapper.innerHTML = `<video class="article-video" loop autoplay muted playsinline>
            <source src=${video}.mov type="video/mp4">
        </video>`
    return videoWrapper;
}

const createArticleBody = (article, id) => {
    const articleBodyWrapper = document.createElement("div");
    articleBodyWrapper.classList.add(id === "projects" ? "page_projectsBodyWrapper" : "page_articleBodyWrapper");
    const title = article.title || article.cardTitle;

    if (title) {
        const articleTitle = document.createElement("h2");
        articleTitle.classList.add(id === "projects" ? "page_projectsTitle" : "page_articleTitle");
        articleTitle.innerHTML = title;
        articleBodyWrapper.appendChild(articleTitle);
    }

    if (article.body || article.cardDescription) {
        const articleBody = document.createElement("div");
        articleBody.classList.add(id === "projects" ? "page_projectsBody" : "page_articleBody");
        
        if (id === "projects") {
            if (article.menuItem[lang].url) {
                const link = document.createElement("a");
                link.href = `/${lang}/${article.menuItem[lang].url}`;
                link.innerHTML = article.cardDescription;
                articleBody.appendChild(link);
            } else {
                articleBody.innerHTML =  article.cardDescription
            }
        } else {
            articleBody.innerHTML = article.body;
        }
        articleBodyWrapper.appendChild(articleBody);
    }

    if (article.video) {
        articleBodyWrapper.appendChild(createPageVideo([article.video]));
    }

    return articleBodyWrapper;
}

const createArticleImage = (article, id, index) => {
    const articleImage = document.createElement("img");
    articleImage.classList.add(id === "projects" ? "page_projectsImg" : !article.body ? "page_fullImage" : "page_articleImg");
    articleImage.src = id === "projects" && article.cardImage ? article.cardImage : article.image;
    articleImage.alt = id === "projects" && article.cardTitle ? article.cardTitle : article.title;
    articleImage.width = !article.body ? 1200 : 800;
    articleImage.height = !article.body ? 600 : 400;
    // index % 2 && ((articleImage.style.order = "-1") && (articleImage.style.marginRight = "30px"))

    if (article.doc) {
        const imageLink = document.createElement("a");
        imageLink.href = article.doc;
        imageLink.onclick = () => {
            window.open(imageLink.href, '_blank');
            return false;
        }
        imageLink.classList.add(!article.body ? "page_fullImage" : "page_imageLink");
        imageLink.appendChild(articleImage);
        return imageLink;
    } else {
        return articleImage;
    }
}

const createArticles = (articles, id, className) => {
    const mainWrapper = document.createElement("div");
    mainWrapper.classList.add(className || "page_article");

    articles?.map((article, index) => {
        const articleWrapper = document.createElement("div");
        articleWrapper.classList.add(id === "projects" ? "page_projectsWrapper" : "page_articleWrapper");

        const content = article[lang] || article;

        if (content.title || content.body || content.cardTitle || content.cardDescription || content.video) {
            articleWrapper.appendChild(createArticleBody(content, id));
        }

        if (content.image || content.cardImage) {
            articleWrapper.appendChild(createArticleImage(content, id, index));
        }
        
        if (content.localVideo) {
            articleWrapper.appendChild(createLocalVideo([content.localVideo]));
        }

        mainWrapper.appendChild(articleWrapper);
    });

    return mainWrapper;
}

const createMetaTags = (item) => {
    const metaTitle = document.head.querySelector("title");
    const metaDescription = document.head.querySelector('meta[name="description"]');
    const url = (item.menuItem && item.menuItem[lang].url) || item[lang].url;
    const titleFromUrl = getTitleFromUrl(url);

    metaTitle.innerHTML = !item.menuItem[lang].metaTitle ? titleFromUrl ? `${titleFromUrl} - ${company.title}` : company.title : item.menuItem[lang].metaTitle;
    metaDescription.content = item.menuItem[lang].metaDescription
      ? item.menuItem[lang].metaDescription
      : createPageMetaDescription(item, url);
}

const createPageMetaDescription = (item, url) => {
    return `${getTitleFromUrl(url)} ${
        item.articles
            ? item.articles.map(article => article.title 
                ? article.title 
                : "").filter(item => item).join(", ")
            : ""
    } - ${company.name} ${company.phone} ${company.address}`;
}

const getTitleFromUrl = (url) => {
    const getString = url.replace(/-|\//g, " ");
    return getString.split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ').trimStart();
}

const createProjectMetaDescription = (project) => {
    const descNode = project.cardDescription && project.cardDescription.replace(/<a[^>]*>|<\/a>|<em>|<\/em>|\./g, "");
    project.metaDescription = `Project ${project.cardTitle} - ${descNode && descNode
        .replace("...", "")} - ${company.name} ${company.phone} ${company.address}`;
}

const createProductBlock = () => {
    const products = menu.filter(item => item.isProduct)
    const productWrap = document.createElement("div");
    const productTitleWrapper = document.createElement("div")
    const productBlockTitle = document.createElement("div");
    const underline = document.createElement("div");
    const productList = document.createElement("ul");

    productTitleWrapper.classList.add("title-wrap");
    productWrap.classList.add("mainPage_product_block");
    productWrap.id = "productBlock";
    productBlockTitle.classList.add("page_title");
    underline.classList.add("menu-item-underline");

    productBlockTitle.innerText = "PRODUCTS";

    products.forEach(item => productList.insertAdjacentHTML('beforeend', createProductListItem(item, lang)));
    productTitleWrapper.appendChild(productBlockTitle);
    productTitleWrapper.appendChild(underline);
    productWrap.appendChild(productTitleWrapper);
    productWrap.appendChild(productList);

    return productWrap;
}

const displayProjects = (projects, menuList, wrapper, item) => {
    const blockWrap = document.createElement("div");
    const currentNode = item || menuList.firstChild;
    const list = menuList.querySelectorAll(".selected_item");

    list.forEach(item => item.classList.remove("selected_item"));
    currentNode.classList.add("selected_item");

    projects[currentNode.id].forEach(project => {
        const projectBlock = document.createElement("div");
        const image = document.createElement("img");
        const textBLock = document.createElement("div");
        const title = document.createElement("div");
        const description = document.createElement("div");
        const button = document.createElement("a");

        image.classList.add("mainPage_project_img");
        textBLock.classList.add("page_projectsBodyWrapper");
        projectBlock.classList.add("page_projectsWrapper");
        title.classList.add("page_projectsTitle");
        description.classList.add("page_projectsBody");

        image.src = project.cardImage;
        title.innerText = project.cardTitle;
        button.innerHTML = project.cardDescription;
        button.href = `/${lang}/${project.menuItem[lang].url}`;

        description.appendChild(button);
        textBLock.appendChild(title);
        textBLock.appendChild(description);
        projectBlock.appendChild(textBLock);
        projectBlock.appendChild(image);
        blockWrap.appendChild(projectBlock);
    })

    wrapper.innerHTML = blockWrap.innerHTML;
}

const getProjectList = (toDisplay) => {
    const projectList = {};

    projects.map(item => item.category)
        .filter((value, index, array) => (array.indexOf(value) === index) && (projectList[value] = []));

    Object.keys(projectList).forEach(item =>
        projects.forEach(project => (item === project.category) && (projectList[item].length < toDisplay) && projectList[item].push(project)));

    return projectList;
}

const createProjectsBlock = (toDisplay) => {
    const projectList = getProjectList(toDisplay);
    const projectTitleWrapper = document.createElement("div");
    const projectBlockTitle = document.createElement("div");
    const underline = document.createElement("div");
    const projectsBlock = document.createElement("div");
    const projectsMenuList = document.createElement("ul");
    const projectsWrap = document.createElement("div");

    projectsBlock.classList.add("mainPage_projects_block");
    projectTitleWrapper.classList.add("title-wrap");
    projectsMenuList.classList.add("mainPage_project_list");
    projectsWrap.classList.add("page_projectsContent");
    projectBlockTitle.classList.add("page_title");
    underline.classList.add("menu-item-underline");

    projectBlockTitle.innerText = "OUR PROJECTS";

    Object.keys(projectList).forEach(item => {
        const menuItem = document.createElement("li");

        menuItem.classList.add("project_menu_item");
        menuItem.innerText = productTitles[item];
        menuItem.id = item;
        menuItem.onclick = (event) => displayProjects(projectList, projectsMenuList, projectsWrap, event.target);

        projectsMenuList.appendChild(menuItem);
    })

    displayProjects(projectList, projectsMenuList, projectsWrap);

    projectTitleWrapper.appendChild(projectBlockTitle);
    projectTitleWrapper.appendChild(underline);
    projectsBlock.appendChild(projectTitleWrapper);
    projectsBlock.appendChild(projectsMenuList);
    projectsBlock.appendChild(projectsWrap);

    return projectsBlock;
}

function getSectionFromEvent(event) {
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    const clientY = event.touches ? event.touches[0].clientY : event.clientY;

    return document.elementFromPoint(clientX, clientY)?.closest("section");
}

function handleSelection(selected) {
    if (selected) {
        const menuItem = document.querySelectorAll(".page_menuItem");
        menuItem.forEach(item => {
            if (item.getAttribute("data-menu-item") === selected.id) {
                item.classList.add("menu_item--selected");
            } else {
                item.classList.remove("menu_item--selected");
            }
        });
    }
}

const createSection = (item, index) => {
    const { articles, category, videos, images, body, id } = item;
    const section = document.createElement("section");
    const titleWrapper = document.createElement("div");
    const titleBlock = document.createElement("h1");
    const titleUnderline = document.createElement("div");
    const pageContentWrapper = document.createElement("div");
    const pageMainContent = document.createElement("div");

    section.addEventListener("wheel", (event) => {
        const selected = getSectionFromEvent(event);
        handleSelection(selected);
    });

    section.addEventListener("touchmove", (event) => {
        const selected = getSectionFromEvent(event);
        handleSelection(selected);
    });

    const title = item.title || item.menuItem[lang].title

    section.id = id;
    titleWrapper.classList.add("title-wrap");
    titleBlock.innerHTML = title.toUpperCase();
    titleBlock.classList.add("page_title")
    titleUnderline.classList.add("menu-item-underline");
    pageContentWrapper.name = id;
    pageContentWrapper.classList.add("page_articles_wrapper");
    pageMainContent.classList.add("page_article");

    section.setAttribute("data-focus", index > 0 ? "false" : "true");

    videos?.length && pageMainContent.appendChild(createPageVideo(videos, title));
    images?.length && pageMainContent.appendChild(createPageImage(images, title));
    body && pageMainContent.appendChild(createPageText(body, "div", "page_mainContent"));

    pageContentWrapper.appendChild(pageMainContent);

    if (id === "projects") {
        const relatedProjects = projects.filter(project => project.category === category);
        pageContentWrapper.appendChild(createArticles(relatedProjects, id, "page_projectsContent"));
    } else {
        articles && pageContentWrapper.appendChild(createArticles(articles, id));
    }

    titleWrapper.appendChild(titleBlock);
    titleWrapper.appendChild(titleUnderline);
    section.appendChild(titleWrapper);
    section.appendChild(pageContentWrapper);
    return section;
}

const createPageContent = (item, menuItem) => {
    const contentBlock = document.querySelector(".page_contentWrapper");
    const productWrap = document.createElement("div");
    const menuPlaceHolder = document.createElement("div");
    const pageMenuWrapper = document.createElement("div");
    const menuTitle = document.createElement("h1");

    menuTitle.innerText = (menuItem && menuItem.menuItem && menuItem.menuItem[lang].title.toUpperCase()) || "";
    menuTitle.classList.add("page-menu-title")
    productWrap.classList.add("page_content_wrapper");
    pageMenuWrapper.classList.add("page_menu_wrapper");

    const id = item.id || item[lang].id;

    if (contentBlock) {
        switch (true) {
            case id === "home":
                // if (item.greeting) {
                //     contentBlock.insertAdjacentHTML('beforeend', createGreetingBlock(item));
                // }
                contentBlock.appendChild(createProductBlock());
                contentBlock.appendChild(createProjectsBlock(8));
                break;
            default:
                const sectionWrapper = document.createElement("div");
                sectionWrapper.classList.add("page_section_wrapper");
                if (menuItem) {
                    contentBlock.appendChild(productWrap);
                    pageMenuWrapper.appendChild(menuTitle);
                    productWrap.appendChild(menuPlaceHolder);
                    sectionWrapper.appendChild(createSection(item))
                    productWrap.appendChild(sectionWrapper);
                } else {
                    sectionWrapper.appendChild(createArticles(item.articles, item.id))
                    contentBlock.appendChild(sectionWrapper);
                }
                break;
        }
    }

    if (item.cardDescription && !item.metaDescription) {
        createProjectMetaDescription(item);
    }

    createMetaTags(item);

    return contentBlock || document.createElement("div");
};

const isActive = (child) => {
    const childUrl = `/${lang}/${child.menuItem?.[lang]?.url || ""}`;
    return window.location.pathname === childUrl;
};

const getSelectedMenuPath = (menu, selectedId, path = []) => {
	for (const item of menu) {
		const id = item.id || item[lang]?.id;
		const currentPath = [...path, item];

		if (id === selectedId) return currentPath;

		if (item.content) {
			const found = getSelectedMenuPath(item.content, selectedId, currentPath);
			if (found) return found;
		}
	}
	return null;
};

const createMenuList = (content, className, isSection) => {
    const menuList = document.createElement("ul");
    className && menuList.classList.add(className);
    content.forEach(child => {
        menuList.appendChild(createMenuListItem(
            child,
            isActive(child) ? ["page_menuItem", "menu_item--selected"] : "page_menuItem",
            false,
            isSection
        ));
    });

    return menuList;
}

const getSelectedMenuPathFromUrl = (menu, lang) => {
    const currentPath = window.location.pathname;
  
    const matchPath = (items, path = []) => {
        for (const item of items) {
            const url = item.menuItem?.[lang]?.url;
            const fullPath = [...path, item];
  
            if (url && currentPath.includes(`/${url}`)) {
                if (item.content) {
                    const childMatch = matchPath(item.content, fullPath);
                    if (childMatch.length) return childMatch;
                }
                return fullPath;
            }
  
            if (item.content) {
                const childMatch = matchPath(item.content, fullPath);
                if (childMatch.length) return childMatch;
            }
        }
  
        return [];
    };
  
    return matchPath(menu);
  };

const createMenuListItem = (child, className, isBurger, isSection) => {
	const menuListItem = document.createElement("li");
	const id = child.id || child[lang]?.id;
	const title = child.menuItem?.[lang]?.menu || id;
	const url = child.menuItem?.[lang]?.url || "#";

	const itemWrapper = document.createElement("div");
	itemWrapper.setAttribute("data-menu-item", id);
	itemWrapper.classList.add(...(Array.isArray(className) ? className : [className]));
	itemWrapper.innerHTML = title.toUpperCase();
	menuListItem.appendChild(itemWrapper);

    if (child.content) {
        itemWrapper.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
    
            const currentItem = menuListItem;
    
            const existingSubmenu = currentItem.querySelector(":scope > ul.submenu");
    
            if (existingSubmenu) {
                existingSubmenu.remove();
            } else {
                const parentUl = currentItem.parentElement;
                parentUl.querySelectorAll(":scope > li > ul.submenu").forEach(ul => {
                    if (!currentItem.contains(ul)) ul.remove();
                });
    
                const submenu = createMenuList(child.content, "submenu", isSection);
                currentItem.appendChild(submenu);
            }
        });
    } else {
		itemWrapper.addEventListener("click", (e) => {
			e.stopPropagation();

			const path = [];
			let current = menuListItem;

			while (current) {
				const dataId = current.querySelector("[data-menu-item]")?.getAttribute("data-menu-item");
				if (dataId) path.unshift(dataId);
				current = current.closest("ul")?.closest("li");
			}

            if (child.id === "contact-us") {
                e.preventDefault();

                const contactUsElement = document.getElementById("footer");
                if (contactUsElement) {
                    contactUsElement.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }

            } else {
			    window.location.href = `/${lang}/${url}`;
            }
		});
	}

	return menuListItem;
};

const createContent = (menuItem, pageWrapper) => {
    const currentPath = window.location.pathname;

    if (menuItem.content) {
        menuItem.content.forEach(item => {
            if (item.content) {
                createContent(item.content, pageWrapper);
            } else if (currentPath.includes(item.menuItem[lang].url)) {
                pageWrapper.appendChild(createPageContent(item, menuItem));
            }
        });
    } else if (menuItem.body) {
        pageWrapper.appendChild(createPageContent(menuItem, menuItem))
    } else {
        menuItem?.forEach(item => {
            if (currentPath.includes(item.menuItem[lang].url)) {
                pageWrapper.appendChild(createPageContent(item, menuItem));
            }
        })
    }
}

const renderMenuList = () => {
    const menuWrapper = document.querySelector(".header_menu");
    const selectedPath = getSelectedMenuPathFromUrl(menu, lang);
    const menuFooter = document.createElement("div");
    
    menuWrapper.innerHTML = "";
    menuFooter.innerText = `${company.copyright}`;
    menuFooter.classList.add("menu-footer");
    
    menuWrapper.appendChild(createHeaderMenu([selectedPath]));
    menuWrapper.appendChild(menuFooter);
} 

const createHeaderMenu = (selectedPaths = []) => {
    const menuList = document.createElement("ul");
    menuList.classList.add("main-menu-wrapper");
  
    menu.forEach(topItem => {
        const topItemId = topItem.id || topItem[lang]?.id;
  
        const isInAnyPath = selectedPaths.some(path =>
            path.some(p => (p.id || p[lang]?.id) === topItemId)
        );
  
        const isLastInAnyPath = selectedPaths.some(path => {
            const last = path[path.length - 1];
            return last && (last.id || last[lang]?.id) === topItemId;
        });
  
        const listItem = createMenuListItem(
            topItem,
            ["header_menuItem"].concat(
                isLastInAnyPath
                ? "menu_item--selected"
                : isInAnyPath
                    ? "menu_item--open"
                    : []
            ),
            false
        );
  
        selectedPaths.forEach(path => {
            const indexInPath = path.findIndex(p => (p.id || p[lang]?.id) === topItemId);
            if (indexInPath !== -1 && topItem.content) {
                let currentMenuData = topItem.content;
                let currentContainer = listItem;
  
                for (let i = indexInPath + 1; i < path.length; i++) {
                    const levelItem = path[i];
                    const levelItemId = levelItem.id || levelItem[lang]?.id;
  
                    const submenu = document.createElement("ul");
                    submenu.classList.add("submenu");
  
                    let nextContainer = null;
  
                    currentMenuData.forEach(child => {
                        const childId = child.id || child[lang]?.id;
                        const isSelected = childId === levelItemId;
  
                        const childListItem = createMenuListItem(
                            child,
                            ["header_menuItem"].concat(
                                isSelected
                                ? i === path.length - 1
                                    ? "menu_item--selected"
                                    : "menu_item--open"
                                : []
                            ),
                            false
                        );
  
                        if (isSelected && child.content) {
                            currentMenuData = child.content;
                            nextContainer = childListItem;
                        }
  
                        submenu.appendChild(childListItem);
                    });
  
                    currentContainer.appendChild(submenu);
                    if (nextContainer) currentContainer = nextContainer;
                }
            }
        });
  
        menuList.appendChild(listItem);
    });
  
    return menuList;
};

const convertToUrl = (title) => {
    return title.toLowerCase().replace(/"/g, '').replace(/\s/g, "-");
}

const createPagesUrl = (entity) => {
    if (entity.content && entity.menuItem[lang].url) {
        entity.content.forEach(item => {
            if (!item.menuItem[lang].url) {
                item.menuItem[lang].url = `${entity.menuItem[lang].url}/${convertToUrl(item.menuItem[lang].title)}`;
                createPagesUrl(item);
            }
        });
    }
}

const createProjectsUrls = (project) => {
    const products = menu.filter(item => item.isProduct);
    project.forEach(item => {
        if (!item.menuItem[lang].url) {
            const parentUrl = products.find(product => item.category === product.id).menuItem[lang].url;
            item.url = `${parentUrl}/${convertToUrl(item.menuItem[lang].title)}`;
            const descNode = new DOMParser().parseFromString(item.cardDescription, "text/html").body.firstElementChild;

            if (!descNode.getAttribute("href")) {
                descNode.href = item.menuItem[lang].url;
            }

            item.cardDescription = descNode.outerHTML;
        }
    })
}

const setCanonical = () => {
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = window.location.href;
    document.head.appendChild(link);
}

[...menu].forEach(item => createPagesUrl(item));
createProjectsUrls(projects);

const sliderContent = [...projects, ...pages]

createSlider(sliderContent, sliders);
setCanonical();

export const createPage = (menuItem) => {
    renderMenuList();
    const main = document.querySelector("#main");
    const header = document.querySelector("#header");
    const productPageWrapper = document.createElement("div")

    productPageWrapper.classList.add("page_wrapper");

    const productPageMenuWrapper = document.createElement("div");
    productPageMenuWrapper.classList.add("page_menuWrapper", "hide_block");

    if (window.location.pathname !== `/${lang}`) {
        productPageWrapper.classList.add("page_padding");
    }

    header.appendChild(createPageHeader(menuItem, productPageMenuWrapper));

    if (menuItem.content) {
        productPageMenuWrapper.appendChild(
            createMenuList(menuItem.content, "product_menu_dropDown")
        );
        header.appendChild(productPageMenuWrapper);
        createContent(menuItem, productPageWrapper);
    } else if (menuItem.body) {
        header.appendChild(productPageMenuWrapper);
        createContent(menuItem, productPageWrapper);
    } else {
        createPageContent(menuItem, productPageWrapper);
    }

    main.appendChild(productPageWrapper);

    const footer = document.querySelector("#footer");
    footer.innerHTML = footerBlock;
}

const callCalculation = (button, callback) => {
    const calcButton = document.querySelector(`#${button}`);
    if (calcButton) {
        calcButton.onclick = (event) => callback(event);
    } else {
        console.error(`Button with id "${button}" not found on the page`);
    }
}

const setGoogleMap = async () => {
    if (!document.head.querySelector("#googleMap")) {
        const script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.id = "googleMap";
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD7KCbbME1QSX-ey2nO2X_gq8Q7ZC1W6jw&loading=async&callback=initMap`;
        window.initMap = async () => {};
        document.head.appendChild(script);
    }
};

const mobileMenuLogic = () => {
    const burger = document.querySelector('.burger_button');
    const burgerWrapper = document.querySelector('.burger_button_wrapper');
    const menu = document.querySelector('.header_menu');

    if (!burger || !burgerWrapper || !menu) return;

    [burger, burgerWrapper].forEach(el => {
        el.addEventListener('click', (e) => {
            e.stopPropagation();
            menu.classList.toggle('hidden');
            burger.setAttribute('aria-expanded', !menu.classList.contains('hidden'));
        });
    });

    document.addEventListener('click', (e) => {
        const clickInsideMenu = menu.contains(e.target);
        const clickOnBurger = burger.contains(e.target);

        if (!clickInsideMenu && !clickOnBurger && !menu.classList.contains('hidden')) {
            menu.classList.add('hidden');
            burger.setAttribute('aria-expanded', "false");
        }
    });
}

const createVideoElement = (src) => {
    const video = document.createElement("video");
    video.loop            = true;
    video.autoplay        = true;
    video.muted           = true;
    video.playsInline     = true;
    video.setAttribute("webkit-playsinline", "");
    video.preload         = "metadata";
    video.id              = "mainVideo";
    video.style.width     = "100%";

    const source = document.createElement("source");
    source.src  = src;
    source.type = "video/mp4";

    video.appendChild(source);

    video.addEventListener("canplaythrough", () => {
        video.play().catch(err => {
            console.warn("Autoplay still failed:", err);
            video.controls = true;
        });
    });

    return video;
};

document.addEventListener("DOMContentLoaded", () => {
    mobileMenuLogic();

    const headerLogo = document.querySelector(".header_logo");
    headerLogo.onclick = () => window.location.href = `/${lang}`;
        
    setTimeout(() => {
        const raw = window.location.pathname;
        const key = raw === "/" ? `/${lang}` : raw;
        const src = videoContent[key];
        if (src) {
            const videoContainer = document.getElementById("videoContainer");
            videoContainer.style.marginBottom = "20px";
            const video = createVideoElement(src);
            videoContainer.appendChild(video);
        }

        switch (true) {
            case window.location.pathname.includes(urls.fastFoot.residential.estimator) ||
                window.location.pathname.includes(urls.fastFoot.commercial.estimator):
                fastFootEstimator();
                break;
            case window.location.pathname.includes(urls.zontBracing.estimator):
                bracingOnChange();
                break;
            case window.location.pathname.includes(urls.fastTube.estimator):
                estimatorOnChange();
                break;
            case window.location.pathname.includes(urls.pages.buyNow):
                const map = document.querySelector(".map");
                if (map) {
                setGoogleMap();
                const articleWrapper = document.querySelector(".page_articleBodyWrapper");
                screen.width > 1280 && articleWrapper?.classList.add("mt-5");
                renderMap();
                }
                break;
            case window.location.pathname.includes(urls.investor.stockChart):
                const script = document.createElement("script");
                script.src = "https://s3.tradingview.com/tv.js";
                script.onload = () => {
                    new TradingView.widget(tradingWidgetConfig);

                    const widget = document.querySelector("#tradingview_c4dab");
                    widget && setTimeout(() => {
                        const child = widget.firstElementChild;
                        if (child) {
                            child.style.maxWidth = "100%";
                            child.firstElementChild.style.maxWidth = "100%";
                        }
                    });
                };
                document.head.appendChild(script);
                break;
            case window.location.pathname.includes("faq"):
                const faqContainer = document.querySelector(".faq-wrapper");

                faqContainer &&
                    faqContainer.addEventListener("click", (e) => {
                        const title = e.target.closest(".faq-title");
                        if (!title) return;

                        const description =
                        title.parentElement.querySelector(".faq-description");
                        const icon = title.querySelector(".fa");

                        if (!description || !icon) return;

                        const isExpanded =
                        !description.classList.contains("hide_block");

                        description.classList.toggle("hide_block");
                        icon.classList.toggle("fa-plus", isExpanded);
                        icon.classList.toggle("fa-minus", !isExpanded);

                        title.setAttribute("aria-expanded", String(!isExpanded));
                    });
                break;
        }

        calcForms.forEach(form => {
            if (window.location.pathname.includes(form.url)) {
                callCalculation(form.button, form.callback);
            }
        })
    
        sliderContent.forEach(project => {
            if (window.location.pathname.includes(project.menuItem[lang].url) && sliders[project.id]) {
                Object.keys(sliders[project.id]).forEach(element => {
                    callThumbnailSlider(element);
                })
            }
        })
        
        window.purechatApi = {
          l: [],
          t: [],
          on: () => this.l.push(arguments),
        };
        (() => {
          var done = false;
          var script = document.createElement("script");
          script.async = true;
          script.type = "text/javascript";
          script.loading = "lazy";
          script.src = "https://app.purechat.com/VisitorWidget/WidgetScript";
          document.body.appendChild(script);
          script.onreadystatechange = script.onload = () => {
            if (!done && (!document.readyState || document.readyState == "loaded" || document.readyState == "complete")) {
              var w = new PCWidget({
                c: "c30363fb-176b-457f-bcb9-ba84707dafc8",
                f: true,
              });
              done = true;
            }
          };
        })();
    }, 300);
})